<template>
  <v-layout v-if="!$apollo.loading" column class="wrapper">
    <v-flex class="title-screen" xs12>
      <span>{{ adminText('workflowsAll.scanned_tickets_a6278d5', 'Scanned tickets') }}</span>
    </v-flex>
    <spinner v-if="$apollo.loading" />
    <div v-else>
      <div class="header">
        <div class="headerTitle">{{ adminText('workflowsAll.total_scanned_tickets_8f65e8a', 'Total scanned tickets') }}</div>
        <div class="headerValues">
          <p class="totalValue">
            <span class="scannedValue">{{ workflowLabel(totalTicketsScanned) }}</span>/{{ workflowLabel(totalTicketsSold) }}
          </p>
        </div>
      </div>
      <div
        v-for="(ticket, index) in tickets"
        :key="index"
        class="pieChart"
        :style="index % 2 == 1 && 'margin-left: 12px'"
      >
        <graph
          :title="workflowLabel(ticket.name)"
          :data-filter="false"
          :has-data="true"
          :value="`${ticket.scanned}/${ticket.total - ticket.scanned}`"
        >
          <pie-chart
            :data="workflowUi({
              labels: [adminText('workflowsAll.scanned_3cffd14', 'Scanned'), adminText('workflowsAll.not_scanned_ed7b58c', 'Not scanned')],
              datasets: [
                {
                  label: adminText('workflowsAll.ticket_data_ef19c51', 'Ticket data'),
                  data: [ticket.scanned, ticket.total - ticket.scanned],
                },
              ],
            })"
            :options="workflowUi({ displayLegend: true })"
          />
        </graph>
      </div>
    </div>
  </v-layout>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
import PieChart from '../../components/shared/graphs/pie-chart.vue'
import Graph from '../shared/graphs/graph.vue'
import Spinner from '../shared/spinner.vue'

import { GET_EVENT_ENTRY_STATS } from '../../graphql/purchase.graphql'

export default {
  mixins: [WorkflowDisplay],
  name: 'scanned-tickets-container',
  components: {
    PieChart,
    Graph,
    Spinner,
  },
  props: {
    eventId: String,
  },
  data() {
    return {
      tickets: null,
      totalTicketsScanned: 0,
      totalTicketsSold: 0,
    }
  },
  computed: {
    hasData() {
      return this.tickets.length > 0
    },
  },
  apollo: {
    getEventEntryStats: {
      query: GET_EVENT_ENTRY_STATS,
      variables() {
        return {
          eventId: this.eventId,
        }
      },
      result({ loading, data }) {
        if (!loading) {
          const {
            getEventEntryStats: { tickets, totalTicketsScanned, totalTicketsSold },
          } = data
          this.totalTicketsScanned = totalTicketsScanned
          this.totalTicketsSold = totalTicketsSold
          this.tickets = tickets
        }
      },
    },
  },
}
</script>

<style scoped>
.wrapper {
  max-width: 1033px;
}
.pieChart {
  display: inline-block;
  margin-top: 12px;
  width: 48.5%;
}
@media screen and (max-width: 550px) {
  .pieChart {
    width: 100%;
    margin-left: 0 !important;
  }
}
.header {
  width: 48.5%;
  max-height: 133px;
  background: #f5f5f5;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
}
@media screen and (max-width: 560px) {
  .header {
    width: 100%;
    height: fit-content;
  }
}
.headerTitle {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  color: #666666;
  margin-left: 24px;
  margin-top: 20px;
  align-self: flex-start;
  margin-right: 24px;
}
.headerValues {
  align-self: flex-start;
  margin-left: 24px;
  font-feature-settings: 'lnum';
}
.scannedValue {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 800;
  font-size: 36px;
  color: #0277bd;
}
.totalValue {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  color: #979797;
}
@media screen and (max-width: 800px) {
  .wrapper{
    margin-top: 1.5rem
  }
}
</style>
